export const Illustrations = {
  DNA_DARK: 'dna-dark',
  DNA_LIGHT: 'dna-light',
  FACE_DARK: 'face-dark',
  FACE_LIGHT: 'face-light',
  HANDS_DARK: 'hands-dark',
  HANDS_LIGHT: 'hands-light',
  HOUSE_DARK: 'house-dark',
  HOUSE_LIGHT: 'house-light',
  SEARCH_DARK: 'search-dark',
  SEARCH_LIGHT: 'search-light',
};
